import React, { Component } from 'react';

export class Video extends Component {
	render() {
		return (
			<div id='portfolio2' className='text-center'>
				<div className='container'>
					<div className='section-title'>
						<h2>
							Ademas podemos complementar tus nuevas aptitudes con otros
							conocimientos relacionados
						</h2>
						<p>
							Si te gusta nuestra propuesta , no dudes en explorar otros cursos
							que también diseñamos para tí. Todo via online , aunque tambien
							podemos ir a donde estés.
						</p>
					</div>

					<div className='row'>
						<div className='portfolio-items'>
							<h4>
								Click sobre las imagenes para informacion sobre otros cursos.
							</h4>

							<div className='col-sm-6 col-md-4 col-lg-4'>
								<div className='portfolio-item'>
									<div className='hover-bg'>
										<div
											className='modal fade'
											id='modal1'
											tabIndex={-1}
											role='dialog'
											aria-labelledby='myModalLabel'
											aria-hidden='true'
										>
											<div className='modal-dialog modal-lg' role='document'>
												<div className='modal-content'>
													<div className='modal-body mb-0 p-0'>
														<div className='embed-responsive embed-responsive-16by9 z-depth-1-half'>
															<iframe
																title='imagen1'
																className='embed-responsive-item'
																src='https://www.youtube.com/embed/A3PDXmYoF5U'
																allowFullScreen
															/>
														</div>
													</div>
													<div className='modal-footer justify-content-center'>
														<span className='mr-4'>Spread the word!</span>
														<a
															type='button'
															className='btn-floating btn-sm btn-fb'
														>
															<i className='fab fa-facebook-f' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-tw'
														>
															<i className='fab fa-twitter' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-gplus'
														>
															<i className='fab fa-google-plus-g' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-ins'
														>
															<i className='fab fa-linkedin-in' />
														</a>
														<button
															type='button'
															className='btn btn-outline-primary btn-rounded btn-md ml-4'
															data-dismiss='modal'
														>
															Close
														</button>
													</div>
												</div>
											</div>
										</div>
										<a>
											<img
												className='img-fluid z-depth-1'
												src='https://mdbootstrap.com/img/screens/yt/screen-video-1.jpg'
												alt='video'
												data-toggle='modal'
												data-target='#modal1'
											/>
										</a>
									</div>
								</div>
							</div>
							<div className='col-sm-6 col-md-4 col-lg-4'>
								<div className='portfolio-item'>
									<div className='hover-bg'>
										<div
											className='modal fade'
											id='modal1'
											tabIndex={-1}
											role='dialog'
											aria-labelledby='myModalLabel'
											aria-hidden='true'
										>
											<div className='modal-dialog modal-lg' role='document'>
												<div className='modal-content'>
													<div className='modal-body mb-0 p-0'>
														<div className='embed-responsive embed-responsive-16by9 z-depth-1-half'>
															<iframe
																title='imagen2'
																className='embed-responsive-item'
																src='https://www.youtube.com/embed/A3PDXmYoF5U'
																allowFullScreen
															/>
														</div>
													</div>
													<div className='modal-footer justify-content-center'>
														<span className='mr-4'>Spread the word!</span>
														<a
															type='button'
															className='btn-floating btn-sm btn-fb'
														>
															<i className='fab fa-facebook-f' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-tw'
														>
															<i className='fab fa-twitter' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-gplus'
														>
															<i className='fab fa-google-plus-g' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-ins'
														>
															<i className='fab fa-linkedin-in' />
														</a>
														<button
															type='button'
															className='btn btn-outline-primary btn-rounded btn-md ml-4'
															data-dismiss='modal'
														>
															Close
														</button>
													</div>
												</div>
											</div>
										</div>
										<a>
											<img
												className='img-fluid z-depth-1'
												src='https://mdbootstrap.com/img/screens/yt/screen-video-1.jpg'
												alt='video'
												data-toggle='modal'
												data-target='#modal1'
											/>
										</a>
									</div>
								</div>
							</div>
							<div className='col-sm-6 col-md-4 col-lg-4'>
								<div className='portfolio-item'>
									<div className='hover-bg'>
										<div
											className='modal fade'
											id='modal1'
											tabIndex={-1}
											role='dialog'
											aria-labelledby='myModalLabel'
											aria-hidden='true'
										>
											<div className='modal-dialog modal-lg' role='document'>
												<div className='modal-content'>
													<div className='modal-body mb-0 p-0'>
														<div className='embed-responsive embed-responsive-16by9 z-depth-1-half'>
															<iframe
																title='imagen3'
																className='embed-responsive-item'
																src='https://www.youtube.com/embed/A3PDXmYoF5U'
																allowFullScreen
															/>
														</div>
													</div>
													<div className='modal-footer justify-content-center'>
														<span className='mr-4'>Spread the word!</span>
														<a
															type='button'
															className='btn-floating btn-sm btn-fb'
														>
															<i className='fab fa-facebook-f' />
														</a>
														<a
															type='button'
															className='btn-floating btn-sm btn-tw'
														>
															<i className='fab fa-twitter'></i>
														</a>

														<button
															type='button'
															className='btn btn-outline-primary btn-rounded btn-md ml-4'
															data-dismiss='modal'
														>
															<i className='fab fa-google-plus-g'></i>
														</button>
														<button
															type='button'
															className='btn btn-outline-primary btn-rounded btn-md ml-4'
															data-dismiss='modal'
														>
															<i className='fab fa-linkedin-in' />
														</button>

														<button
															type='button'
															className='btn btn-outline-primary btn-rounded btn-md ml-4'
															data-dismiss='modal'
														>
															Close
														</button>
													</div>
												</div>
											</div>
										</div>
										<a>
											<img
												className='img-fluid z-depth-1'
												src='https://mdbootstrap.com/img/screens/yt/screen-video-1.jpg'
												alt='video'
												data-toggle='modal'
												data-target='#modal1'
											/>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Video;
